<script setup lang="ts">
import { computed } from 'vue';
import { parseBlocks } from '../mini-markdown';
import InlineText from './InlineText.vue';

/** The text of a release note: paragraphs, lists, headings, bold, code, links (never raw HTML). */
const props = defineProps<{ text: string }>();
const blocks = computed(() => parseBlocks(props.text));
</script>

<template>
  <div class="note-text">
    <template v-for="(b, i) in blocks" :key="i">
      <h4 v-if="b.t === 'h'"><InlineText :parts="b.text" /></h4>
      <ul v-else-if="b.t === 'ul'">
        <li v-for="(it, j) in b.items" :key="j"><InlineText :parts="it" /></li>
      </ul>
      <p v-else><InlineText :parts="b.text" /></p>
    </template>
  </div>
</template>

<style scoped>
.note-text {
  display: grid;
  gap: 6px;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--text-2);
}
.note-text p,
.note-text h4 {
  margin: 0;
}
.note-text h4 {
  font-size: 13.5px;
  color: var(--text);
}
.note-text ul {
  margin: 0;
  padding-left: 20px;
  display: grid;
  gap: 3px;
}
.note-text a {
  color: var(--accent);
}
.note-text code {
  font-family: ui-monospace, Consolas, monospace;
  font-size: 12.5px;
  padding: 0 5px;
  border-radius: 6px;
  background: var(--panel-2);
}
</style>
